var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"uk-section uk-section-secondary uk-padding-small uk-margin-remove"},[_c('p',[_vm._v("Headlines App")]),_vm._v(" "),_c('small',{staticClass:"uk-text-muted"},[_vm._v("\n      "+_vm._s(_vm.year)+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a543f76","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Footer.vue
// module id = 58
// module chunks = 0